var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.66,
    height: 19.964,
    viewBox: "0 0 15.66 19.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Localizaciones",
    transform: "translate(-6.929 -5.714)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_335",
    "data-name": "Elipse 335",
    cx: 7.83,
    cy: 1.566,
    rx: 7.83,
    ry: 1.566,
    transform: "translate(6.929 22.546)",
    fill: "#90dfaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7700",
    "data-name": "Trazado 7700",
    d: "M255.462,373.57h-.036V376.7h.036c4.324,0,7.83-.7,7.83-1.566S259.787,373.57,255.462,373.57Z",
    transform: "translate(-240.703 -351.024)",
    fill: "#6fc186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7701",
    "data-name": "Trazado 7701",
    d: "M163.979,108.606a6.242,6.242,0,0,0-6.242,6.242c0,5.3,6.242,12.484,6.242,12.484s6.242-6.857,6.242-12.484A6.242,6.242,0,0,0,163.979,108.606Zm0,9.363a3.121,3.121,0,1,1,3.121-3.121A3.121,3.121,0,0,1,163.979,117.969Z",
    transform: "translate(-149.22 -102.892)",
    fill: "#ffd15d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7702",
    "data-name": "Trazado 7702",
    d: "M261.7,114.848a6.242,6.242,0,0,0-6.242-6.242h-.036v3.121h.036a3.121,3.121,0,1,1,0,6.242h-.036v9.322l.036.042S261.7,120.475,261.7,114.848Z",
    transform: "translate(-240.703 -102.892)",
    fill: "#f9b54c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dedb5910dbd3efbe8c7432aa93bb0a8c.svg";
export { ForwardRef as ReactComponent };